import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Container from '@material-ui/core/Container';
import withStyles from '@material-ui/core/styles/withStyles';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/core/styles';
import onlinePajakMuiTheme from './theme/onlinePajakMuiTheme';
import VendorAppBar from './components/vendor-app-bar/vendor-app-bar';
import AppRouteSwitch from './AppRouteSwitch';

const appUseStyles = (theme) => ({
  theme: theme.mixins.toolbar,
  root: {
    paddingTop: `2em`
  }
});

function App(props) {
  const { classes } = props;
  return (
    <ThemeProvider theme={onlinePajakMuiTheme}>
      <VendorAppBar />
      <CssBaseline />
      <div className={classes.theme} />
      <Container fixed={true} className={classes.root}>
        <Router>
          <AppRouteSwitch />
        </Router>
      </Container>
    </ThemeProvider>
  );
}

export default withStyles(appUseStyles)(App);
